import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  ChangeEvent,
} from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import { FiCamera } from 'react-icons/fi';

import api from '../../../../../../../services/api';

import no_image from '../../../../../../../assets/no_image.png';
import InputLogged from '../../../../../../../components/InputLogged';
import Select from '../../../../../../../components/Select';
import TextAreaLogged from '../../../../../../../components/TextAreaLogged';

import getValidationErrors from '../../../../../../../utils/getValidationErrors';
import resizeFile from '../../../../../../../utils/resizeFile';
import { useToast } from '../../../../../../../hooks/toast';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';
import { useEditProduto } from '../../../../../../../hooks/editProduto';
import { useAuth } from '../../../../../../../hooks/auth';

import {
  TabWrapper,
  LabelWrapper,
  NewImg,
  ButtonAction,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';
import material_styles from '../../../drawer_styles/material_styles';

interface OptionType {
  id: string;
  value: string;
  label: string;
}

interface DetalhesProps {
  produto_id: number;
  tipo_produto: number;
  grupo_id: number;
  unidade_medida_id: number;
}

// interface ProdutoProps {
//   id: number;
//   unidade_medida_id: number;
//   descricao: string;
//   codigo: string;
//   gtin: string;
//   tipo: number;
//   preco: number;
//   observacao: string;
//   imagem: string;
//   estoque_minimo: number;
//   estoque_atual: number;
// }

// Origem da mercadoria (NFC-e) — códigos 0 a 8.
const origemOptions: OptionType[] = [
  { id: '0', value: '0', label: '0 - Nacional' },
  { id: '1', value: '1', label: '1 - Estrangeira (importação direta)' },
  { id: '2', value: '2', label: '2 - Estrangeira (adquirida no mercado interno)' },
  { id: '3', value: '3', label: '3 - Nacional (>40% de conteúdo importado)' },
  { id: '4', value: '4', label: '4 - Nacional (processos produtivos básicos)' },
  { id: '5', value: '5', label: '5 - Nacional (<40% de conteúdo importado)' },
  { id: '6', value: '6', label: '6 - Estrangeira (importação direta, sem similar)' },
  { id: '7', value: '7', label: '7 - Estrangeira (mercado interno, sem similar)' },
  { id: '8', value: '8', label: '8 - Nacional (conteúdo importado >70%)' },
];

const Detalhes: React.FC<DetalhesProps> = ({
  produto_id,
  tipo_produto,
  grupo_id,
  unidade_medida_id,
}) => {
  const [optionsGroup, setOptionsGroup] = useState<OptionType[]>([]);
  // const [produto, setProduto] = useState<ProdutoProps>({} as ProdutoProps);
  const [optionsUnidadeMedida, setOptionsUnidadeMedida] = useState<
    OptionType[]
  >([]);
  const [unidadeSelected, setUnidadeSelected] = useState<OptionType>(
    {} as OptionType,
  );
  const [btnDisable, setBtnDisable] = useState(false);

  // ---------- Fiscal NFC-e (Story 1-4 / T1.38) ----------
  const [categoriaOptions, setCategoriaOptions] = useState<OptionType[]>([]);
  const [categoriaSelected, setCategoriaSelected] = useState<OptionType | null>(
    null,
  );
  const [origemSelected, setOrigemSelected] = useState<OptionType | null>(null);
  const [emissaoHabilitada, setEmissaoHabilitada] = useState(false);
  const [showOverrides, setShowOverrides] = useState(false);

  const [selectedOptionGroup, setSelectedOptionGroup] = useState({});
  const formRef = useRef<FormHandles>(null);

  const {
    handleSetHasProductUpdated,
    handleSetDrawerWasClosed,
  } = useRegisterAdded();

  const {
    produto,
    disponibilidade,
    handleSetProduto,
    turnos,
  } = useEditProduto();

  const { addToast } = useToast();
  const { user } = useAuth();

  const classes = material_styles();

  useEffect(() => {
    async function loadUnidades(): Promise<void> {
      const response = await api.get('/unidade_medida');

      const optionItems: OptionType[] = [];

      response.data.map((unidade_medida: any) => {
        const option = {
          id: unidade_medida.id.toString(),
          value: unidade_medida.id.toString(),
          label: unidade_medida.sigla,
        };

        optionItems.push(option);

        if (unidade_medida.id == produto.unidade_medida_id) {
          setUnidadeSelected({
            id: unidade_medida.id,
            value: unidade_medida.id,
            label: unidade_medida.sigla,
          });
        }
      });

      setOptionsUnidadeMedida(optionItems);
    }

    async function loadGroups(): Promise<void> {
      const response = await api.get(
        `/grupo/${tipo_produto === 2 ? '4' : '1'}`,
      );

      const optionItems: OptionType[] = [];

      response.data.map((grupo: any) => {
        const option = {
          id: grupo.id,
          value: grupo.id,
          label: grupo.descricao,
        };

        optionItems.push(option);

        if (grupo_id == grupo.id) {
          setSelectedOptionGroup({
            id: grupo.id,
            value: grupo.id,
            label: grupo.descricao,
          });
        }
      });

      setOptionsGroup([...optionItems]);
    }

    async function loadFiscal(): Promise<void> {
      try {
        const [{ data: categorias }, { data: empresa }] = await Promise.all([
          api.get(`/companies/${user.empresa_id}/categorias-fiscais`),
          api.get(`/empresa/${user.empresa_id}`),
        ]);

        const optionItems: OptionType[] = (categorias || []).map(
          (categoria: any) => ({
            id: String(categoria.id),
            value: String(categoria.id),
            label: categoria.descricao,
          }),
        );
        setCategoriaOptions(optionItems);
        setEmissaoHabilitada(!!empresa.emissao_habilitada);

        if (produto.categoria_fiscal_id) {
          setCategoriaSelected(
            optionItems.find(
              (o) => o.value === String(produto.categoria_fiscal_id),
            ) || null,
          );
        }
        if (produto.origem_override !== undefined && produto.origem_override !== null) {
          setOrigemSelected(
            origemOptions.find(
              (o) => o.value === String(produto.origem_override),
            ) || null,
          );
        }
      } catch (err) {
        // Falha ao carregar dados fiscais não bloqueia a edição do produto.
      }
    }

    loadUnidades();
    loadGroups();
    loadFiscal();
  }, [produto_id, tipo_produto, grupo_id, produto.unidade_medida_id]);

  const handleChangeSelectedGroup = useCallback(
    (data: any) => {
      setSelectedOptionGroup(data);
      handleSetProduto({ ...produto, grupo_id: data.id });
    },
    [handleSetProduto, produto],
  );

  const handleChangeSelectedUnidadeMedida = useCallback(
    (data: any) => {
      setUnidadeSelected(data);
      handleSetProduto({ ...produto, unidade_medida_id: data.id });
    },
    [handleSetProduto, produto],
  );

  const handleProdutoImgChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const data = new FormData();
        const image = await resizeFile(e.target.files[0]);

        data.append('produto_img', image);

        api.patch(`/produto/${produto_id}`, data).then((response) => {
          addToast({
            type: 'success',
            title: 'Imagem Atualizada',
          });

          handleSetProduto({ ...produto, imagem: response.data.imagem });
        });
      }
    },
    [produto_id, produto, addToast],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        setBtnDisable(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          descricao: Yup.string().required('O nome do produto é obrigatório'),
          observacao: Yup.string().max(
            500,
            'A descrição do produto deve ter no máximo 500 caracteres',
          ),
          preco: Yup.number()
            .positive('Informe um preço válido.')
            .required('O preço do produto é obrigatório')
            .typeError('O preço do produto é obrigatório'),
        });

        await schema.validate(data, { abortEarly: false });

        // Categoria Fiscal obrigatória quando a empresa emite NFC-e (B2/D2 - AC9).
        if (emissaoHabilitada && !categoriaSelected?.value) {
          formRef.current?.setFieldError(
            'categoria_fiscal_id',
            'Categoria Fiscal é obrigatória quando a emissão está habilitada.',
          );
          addToast({
            type: 'error',
            title: 'Categoria Fiscal obrigatória',
            description: 'Selecione a categoria fiscal do produto.',
          });
          setBtnDisable(false);
          return;
        }

        let productRequest;
        let preco;

        const productWillBeStored = {
          unidade_medida_id: produto.unidade_medida_id,
          descricao: produto.descricao,
          codigo: produto.codigo ? produto.codigo : null,
          gtin: produto.gtin ? produto.gtin : null,
          observacao: produto.observacao,
          empresa_id: user.empresa_id,
          grupo_id: produto.grupo_id,
          // Fiscal NFC-e (Story 1-4 / T1.38)
          categoria_fiscal_id: categoriaSelected?.value
            ? Number(categoriaSelected.value)
            : null,
          ncm_override: data.ncm_override || null,
          cfop_override: data.cfop_override || null,
          cest_override: data.cest_override || null,
          origem_override: origemSelected?.value ?? null,
        };

        const estoqueData = {
          estoque_minimo: produto.estoque_minimo,
          estoque_atual: produto.estoque_atual,
        };

        if (tipo_produto === 2) {
          productRequest = await api.put(`/produto/${produto.id}`, {
            ...productWillBeStored,
            preco_custo: data.preco,
          });

          preco = productRequest.data.preco_custo;
        } else {
          productRequest = await api.put(`/produto/${produto.id}`, {
            ...productWillBeStored,
          });
          const precoRequest = await api.put(`/produto/preco/${produto.id}`, {
            valor: produto.preco,
            grupo_id: productWillBeStored.grupo_id,
          });

          preco = precoRequest.data.valor;

          await api.put(`/produto/disponibilidade/${produto_id}`, {
            role: { dias: disponibilidade.dias, turnos },
          });
        }

        const estoqueRequest = await api.put(`/estoque/${produto.id}`, {
          estoque_minimo: estoqueData.estoque_minimo,
          estoque_atual: estoqueData.estoque_atual,
        });

        const { descricao, unidade_medida } = productRequest.data;

        handleSetProduto({
          ...produto,
          preco,
          descricao,
          unidade_medida_id: unidade_medida.id,
          estoque_minimo: estoqueRequest.data.estoque_minimo,
          estoque_atual: estoqueRequest.data.estoque_atual,
        });

        addToast({
          type: 'success',
          title: `O produto ${descricao} foi atualizado`,
        });

        handleSetHasProductUpdated(true);
        handleSetDrawerWasClosed(true);
        setBtnDisable(false);
      } catch (err) {
        console.log(err);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'Preencha os dados corretamente pra continuar',
          });
        } else {
          addToast({
            type: 'error',
            title: err?.response.data?.message || 'Erro',
          });
        }

        setBtnDisable(false);
      }
    },
    [
      addToast,
      handleSetHasProductUpdated,
      tipo_produto,
      disponibilidade,
      turnos,
      produto,
      unidadeSelected,
      user,
      emissaoHabilitada,
      categoriaSelected,
      origemSelected,
    ],
  );

  const handleInputChange = useCallback(
    (e: any, input_name: string) => {
      switch (input_name) {
        case 'descricao':
          handleSetProduto({ ...produto, descricao: e.target.value });
          return;
        case 'observacao':
          handleSetProduto({ ...produto, observacao: e.target.value });
          return;
        case 'estoque_minimo':
          handleSetProduto({
            ...produto,
            estoque_minimo: Number(e.target.value),
          });
          return;
        case 'estoque_atual':
          handleSetProduto({
            ...produto,
            estoque_atual: Number(e.target.value),
          });
          return;
        case 'preco':
          handleSetProduto({ ...produto, preco: Number(e.target.value) });
          return;
        case 'codigo':
          handleSetProduto({ ...produto, codigo: e.target.value });
          return;
        case 'gtin':
          handleSetProduto({ ...produto, gtin: e.target.value });
      }
    },
    [handleSetProduto, produto],
  );

  return (
    <TabWrapper>
      <Form
        ref={formRef}
        onSubmit={handleSubmit}
        initialData={{
          descricao: produto.descricao,
          observacao: produto.observacao,
          codigo: produto.codigo,
          gtin: produto.gtin,
          preco: produto.preco,
          estoque_minimo: produto.estoque_minimo,
          estoque_atual: produto.estoque_atual,
          ncm_override: produto.ncm_override,
          cfop_override: produto.cfop_override,
          cest_override: produto.cest_override,
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={8} className={classes.noPaddingTop}>
            <Grid container spacing={3}>
              <Grid item xs={12} className={classes.noPaddingBot}>
                <LabelWrapper>
                  <span>Grupo:</span>
                </LabelWrapper>
                <Select
                  value={selectedOptionGroup}
                  name="grupo_id"
                  onChange={handleChangeSelectedGroup}
                  placeholder="Selecione o grupo"
                  options={optionsGroup}
                />
              </Grid>

              <Grid item xs={12} className={classes.noVerticalPadding}>
                <LabelWrapper>
                  <span>Nome do produto:</span>
                </LabelWrapper>
                <InputLogged
                  name="descricao"
                  placeholder="Nome do produto"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e, 'descricao')
                  }
                />
              </Grid>

              <Grid item xs={12} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Descrição:</span>
                </LabelWrapper>
                <TextAreaLogged
                  name="observacao"
                  placeholder="Detalhes do produto e informações para o cliente."
                  rows={3}
                  onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                    handleInputChange(e, 'observacao')
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4} className={classes.noVerticalPadding}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <LabelWrapper>
                  <span>Imagem do Produto:</span>
                </LabelWrapper>
                <NewImg>
                  <img
                    src={
                      produto.imagem
                        ? `${process.env.REACT_APP_SERVER_URL}/files/${produto.imagem}`
                        : no_image
                    }
                    alt="Grupo"
                  />

                  <label htmlFor="imagem">
                    <FiCamera size={20} />
                    <input
                      type="file"
                      id="imagem"
                      onChange={handleProdutoImgChange}
                    />
                  </label>
                </NewImg>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={6} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Estoque Mínimo:</span>
                </LabelWrapper>

                <InputLogged
                  name="estoque_minimo"
                  placeholder="Estoque Mínimo"
                  type="number"
                  step=".001"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e, 'estoque_minimo')
                  }
                />
              </Grid>

              <Grid item xs={6} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Estoque Atual:</span>
                </LabelWrapper>

                <InputLogged
                  name="estoque_atual"
                  placeholder="Estoque Atual"
                  type="number"
                  step=".001"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e, 'estoque_atual')
                  }
                />
              </Grid>

              <Grid item xs={6} className={classes.noPaddingTop}>
                {tipo_produto === 2 ? (
                  <>
                    <LabelWrapper>
                      <span>Preço Custo:</span>
                    </LabelWrapper>

                    <InputLogged
                      name="preco"
                      placeholder="Preço Custo"
                      type="number"
                      step=".001"
                    />
                  </>
                ) : (
                  <>
                    <LabelWrapper>
                      <span>Preço:</span>
                    </LabelWrapper>

                    <InputLogged
                      name="preco"
                      placeholder="Preço"
                      type="number"
                      step=".001"
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleInputChange(e, 'preco')
                      }
                    />
                  </>
                )}
              </Grid>

              <Grid item xs={6} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Unidade de Medida:</span>
                </LabelWrapper>
                <Select
                  value={unidadeSelected}
                  name="unidade_medida_id"
                  placeholder="Selecione"
                  options={optionsUnidadeMedida}
                  onChange={handleChangeSelectedUnidadeMedida}
                />
              </Grid>

              <Grid item xs={6} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Código PDV:</span>
                </LabelWrapper>
                <InputLogged
                  name="codigo"
                  placeholder="Código"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e, 'codigo')
                  }
                />
              </Grid>

              <Grid item xs={6} className={classes.noPaddingTop}>
                <LabelWrapper>
                  <span>Código de barras:</span>
                </LabelWrapper>
                <InputLogged
                  name="gtin"
                  placeholder="Código de Barras"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e, 'gtin')
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} className={classes.noPaddingBot}>
                <LabelWrapper>
                  <span>
                    Categoria Fiscal
                    {emissaoHabilitada ? ' (obrigatória)' : ''}:
                  </span>
                </LabelWrapper>
                <Select
                  value={categoriaSelected}
                  name="categoria_fiscal_id"
                  placeholder="Selecione a categoria fiscal"
                  options={categoriaOptions}
                  isClearable
                  onChange={(data: any) => setCategoriaSelected(data)}
                />
              </Grid>

              <Grid item xs={12} className={classes.noVerticalPadding}>
                <ButtonAction
                  type="button"
                  className="cancel"
                  onClick={() => setShowOverrides((prev) => !prev)}
                >
                  {showOverrides
                    ? 'Ocultar exceções fiscais'
                    : 'Exceções fiscais deste produto (opcional)'}
                </ButtonAction>
              </Grid>

              <Grid item xs={12} className={classes.noPaddingTop}>
                <Collapse in={showOverrides}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <LabelWrapper>
                        <span>NCM (exceção):</span>
                      </LabelWrapper>
                      <InputLogged name="ncm_override" placeholder="NCM" />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelWrapper>
                        <span>CFOP (exceção):</span>
                      </LabelWrapper>
                      <InputLogged name="cfop_override" placeholder="CFOP" />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelWrapper>
                        <span>CEST (exceção):</span>
                      </LabelWrapper>
                      <InputLogged name="cest_override" placeholder="CEST" />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelWrapper>
                        <span>Origem (exceção):</span>
                      </LabelWrapper>
                      <Select
                        value={origemSelected}
                        name="origem_override"
                        placeholder="Origem da mercadoria"
                        options={origemOptions}
                        isClearable
                        onChange={(data: any) => setOrigemSelected(data)}
                      />
                    </Grid>
                  </Grid>
                </Collapse>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                id="submit_button"
                disabled={btnDisable}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Detalhes;
